import { ButtonVariants } from '@/components/atoms/Button/Button';
import ButtonLink from '@/components/atoms/ButtonLink/ButtonLink';
import Image from '@/components/atoms/Image';
import { useAuth } from '@/hooks/useAuth';
import { BECOME_A_DEALER_ROUTE, GOOGLE_TRACK_INFO } from '@/lib/constants';
import React from 'react';

const NewPartnerPageBanner: React.FC = () => {
  const { user } = useAuth();
  return (
    <article
      className={`m:w6-[50px] py-[40px] text-center m:mx-auto m:py-[100px] l:w-[873px]`}
    >
      <header className={'flex flex-col items-center'}>
        <Image
          src="/images/desktop-xl-ev-11.png"
          width={535}
          height={489}
          alt="Cars on a road in a city"
          className="mb-[60px]"
        />
        <h1 className="mb-6 text-left text-h2SemiBold">
          Let&apos;s accelerate the transition towards{' '}
          <span className="text-brandElectric">zero-emission mobility </span>
          together.
        </h1>
      </header>
      <p className="mb-[60px] text-left text-subtitle16px text-neutral-900">
        Sell more EVs when you partner with us.
      </p>

      <div className="max-m:space-y-4 m:flex m:justify-center m:space-x-5 m:whitespace-nowrap">
        <ButtonLink
          aria-label="Join waitlist & apply"
          variant={ButtonVariants.Secondary}
          analyticsEvent={{
            ...GOOGLE_TRACK_INFO.contactSalesButton,
            pageTarget: BECOME_A_DEALER_ROUTE,
          }}
          target="_blank"
          href={`${BECOME_A_DEALER_ROUTE}${user ? '?partner_redirect=true' : ''}`}
        >
          Join waitlist & apply
        </ButtonLink>
      </div>
    </article>
  );
};

export default NewPartnerPageBanner;
